<template>
    <div class="order-list">
        <div class="order-container">
            <div class="search-box">
                <div class="item">
                    <span class="text">訂單編號：</span>
                    <a-input style="width:200px;" placeholder="订单编号" v-model="para.orderCode"></a-input>
                </div>
                <div class="item">
                    <span class="text">收件人名字：</span>
                    <a-input style="width:200px;" placeholder="姓名" v-model="para.receiverName"></a-input>
                </div>
                <div class="item">
                    <span class="text">收件人手機：</span>
                    <a-input style="width:200px;" placeholder="手机号" v-model="para.receiverPhone"></a-input>
                    <a-button style="margin-left:20px;" @click="search">搜索</a-button>
                </div>
            </div>
            <a-table :pagination="false" :loading="tbLoading" :data-source="list" row-key="id">
                <a-table-column
                        align="center"
                        title="商品信息">
                    <template slot-scope="row,item">
                        <div class="pro-box">
                            <img :src="item.orderItemResponse.productImages[0]" alt="" class="pro-img">
                            <p class="pro-name">{{item.orderItemResponse.productTitle}}</p>
                          <p class="sku-name">
                            商品属性:{{ item.orderItemResponse.skuDesc ? item.orderItemResponse.skuDesc : '默认' }}</p>
                          <p class="pro-num">数量：{{ item.orderItemResponse.buyNum }}</p>
                        </div>
                    </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="收件人信息">
                    <template slot-scope="row,item">
                        <p>{{item.receiverInfo.receiverName}}</p>
                        <p>{{item.receiverInfo.receiverPhone}}</p>
                        <p>{{item.receiverInfo.provinceName + ' ' + item.receiverInfo.cityName + ' ' + (item.receiverInfo.districtName ? item.receiverInfo.districtName : '') + ' ' + item.receiverInfo.addressDetail}}</p>
                    </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="訂單編號"
                        data-index="orderCode"></a-table-column>
                <a-table-column
                        align="center"
                        title="訂單金額">
                  <template slot-scope="row,item">
                    <span class="red">訂單總額：¥{{(item.orderAmount/100).toFixed(2)}}元</span><br>
                    <span class="red">訂單郵費：¥{{item.postageAmount > 0 ?(item.postageAmount/100).toFixed(2) + '元' : '包郵'}}</span>
                  </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="操作時間">
                    <template slot-scope="row,item">
                        <p>下單時間：{{item.orderTime | trans-date}}</p>
                        <p v-if="item.payTime">支付時間：{{item.payTime | trans-date}}</p>
                    </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="操作">
                    <template slot-scope="row,item">
                        <a-button size="small" type="link"  v-if="item.orderState === 20" @click="showSend(item)">發貨</a-button>
                        <a-button size="small" :loading="exLoading" @click="exShow(item)" v-if="item.orderState === 30">查看物流</a-button>
                        <a-button size="small" v-if="item.orderState === 30" @click="showUp(item)">修改物流</a-button>
                    </template>
                </a-table-column>
            </a-table>
            <a-pagination :defaultPageSize="para.pageSize" :defaultCurrent="para.pageIndex" :total="total" @change="currentChange" />
        </div>
        <a-modal
                title="物流詳情"
                :visible="showEx"
                :getContainer="getContainer"
                @cancel="exCancel"
                :footer="null">
            <p style="text-align: left;" v-if="exInfo">快遞公司：{{exInfo.cname}}</p>
            <p style="text-align: left;" v-if="exInfo">快遞單號：{{exInfo.no}}</p>
            <div class="list-box" v-if="exList.length">
                <a-steps progress-dot :current="0" direction="vertical">
                    <a-step v-for="(item,index) in exList" :key="index" :title="item.content" :description="item.time" />
                </a-steps>
            </div>
            <p style="margin-top:70px;text-align: center;" v-else>暫無數據</p>
        </a-modal>
        <a-modal
                title="修改寫物流單號"
                :visible="upShow"
                :confirm-loading="confirmLoading"
                @ok="upOk"
                @cancel="upCancel"
        >
            <p style="color:#ff3657;">請輸入快遞單號，系統自動識別快遞公司</p>
            <a-input placeholder="輸入快遞單號" v-model="exNum"></a-input>
        </a-modal>
        <a-modal
                title="填寫物流單號"
                :visible="sendShow"
                :confirm-loading="confirmLoading"
                @ok="sendOk"
                @cancel="sendCancel"
        >
            <p style="color:#ff3657;">請輸入快遞單號，系統自動識別快遞公司</p>
            <a-input placeholder="輸入快遞單號" v-model="exNum"></a-input>
        </a-modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                exLoading:false,
                tbLoading:false,
                list:[],
                para:{
                    orderCode:undefined,
                    orderState:20,
                    receiverName:undefined,
                    receiverPhone:undefined,
                    pageIndex:1,
                    pageSize:8
                },
                hide:false,
                total:0,
                showEx:false,
                exList:[],
                exInfo:undefined,
                upShow:false,
                confirmLoading:false,
                exNum:undefined,
                activeId:undefined,
                sendShow:false,
                sendId:undefined
            }
        },
        methods: {
            showSend(item){
                this.sendId=item.id;
                this.sendShow=true;
            },
            sendOk(){
                let self=this;
                if(this.exNum==='' || !this.exNum){
                    this.$Message.warning('請輸入物流單號');
                    return false;
                }
                this.confirmLoading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/order/deliver',
                    data:{
                        expressInfo:this.exNum,
                        id:this.sendId
                    }
                }).then(res=>{
                    self.confirmLoading=false;
                    self.$Message.success('發貨成功');
                    self.sendCancel()
                    self.getList()
                })
            },
            sendCancel(){
                this.exNum=undefined;
                this.sendId=undefined;
                this.sendShow=false;
            },
            showUp(item){
                this.activeId=item.id;
                this.upShow=true;
            },
            upCancel(){
                this.upShow=false;
                this.exNum=undefined;
                this.activeId=undefined;
            },
            upOk(){
                let self=this;
                if(this.exNum === '' || !this.exNum){
                    this.$Message.warning('請輸入快遞單號');
                    return false;
                }
                self.confirmLoading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/order/update',
                    data:{
                        id:this.activeId,
                        expressInfo:this.exNum
                    }
                }).then(res=>{
                    self.$Message.success('操作成功');
                    self.getList();
                    self.confirmLoading=false;
                    self.upCancel()
                }).catch(err=>{
                    self.$Message.error(JSON.stringify(err));
                    self.confirmLoading=false;
                })
            },
            getContainer() {
                return document.getElementsByClassName('order-list')[0]
            },
            exShow(item){
                let self=this;
                self.exLoading=true;
                self.$http({
                    method: 'get',
                    url: '/manager/order/trace',
                    params:{
                        id:item.id
                    }
                }).then(res=>{
                    self.showEx=true;
                    self.exList=res.data && res.data.list ? res.data.list :[]
                    self.exInfo=res.data;
                    self.exLoading=false;
                })
            },
            exCancel(){
                this.exList=[];
                this.showEx=false;
            },
            currentChange(val){
                this.para.pageIndex=val;
                this.getList();
            },
            search(){
                this.para.pageIndex=1;
                this.getList();
            },
            getList(){
                let self=this;
                this.tbLoading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/order/list',
                    data:self.para
                }).then(res=>{
                    self.tbLoading=false;
                    self.list=res.data && res.data.list ? res.data.list :[]
                    self.total=res.data && res.data.totalRows ? res.data.totalRows : 0
                })
            },
            del(item){

            },
        },
        created() {
            this.getList();
            this.$emit('breadcrumbChange',['賬號管理','付款訂單管理'])
        },
    }
</script>
<style lang="less">
    .order-list{
        .list-box{
            margin-top:20px;
        }
        .ant-steps-item-content{
            width:420px;
        }
        .order-container{
            padding:20px;
            .search-box{
                margin-bottom:20px;
                overflow: hidden;
                .item{
                    float:left;
                    margin-right:20px;
                    margin-bottom:20px;
                    .text{
                        font-size: 14px;
                        color:#333;
                    }
                }
            }
            .red{
                color:#ff3657;
            }
          .pro-box {
            display: flex;
            position: relative;
            .sku-name {
              position: absolute;
              bottom: 0;
              left: 120px;
              color:#e98821;
              text-align: left;
              font-size: 12px;
            }
            .pro-num{
              position: absolute;
              bottom:-20px;
              color:#e98821;
              left:120px;
              font-size: 12px;
            }
            .pro-img {
              width: 100px;
              height: 100px;
              object-fit: cover;
              display: block;
              margin-right: 20px;
            }

            .pro-name {
              color: #333;
              text-align: left;
              font-size: 14px;
              max-width: 200px;
            }
          }
        }
    }
</style>